"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class SchoolParentEntityDoesNotExistError extends client_library_1.ExtendableError {
    constructor(schoolId, userId) {
        super(`School parent entity does not exist for schoolId: ${schoolId} and userId: ${userId} pair`);
    }
}
exports.default = SchoolParentEntityDoesNotExistError;
//# sourceMappingURL=SchoolParentEntityDoesNotExistError.js.map